import { Quote } from "lucide-react";

const gallery = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1682865599016-9ab16ec1a905?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGhlYWx0aHklMjBzaGlueSUyMGZsb3dpbmclMjBoYWlyJTIwcG9ydHJhaXQlMjBsdXh1cnl8ZW58MHx8fHwxNzc2NDM3NDk5fDA&ixlib=rb-4.1.0&q=85",
    service: "Escova Progressiva",
    testimonial: "Nunca imaginei meu cabelo assim. Brilho, alinhamento e muito mais fácil de cuidar.",
    client: "Marina A.",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1610983394051-356c11878d54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGhlYWx0aHklMjBzaGlueSUyMGZsb3dpbmclMjBoYWlyJTIwcG9ydHJhaXQlMjBsdXh1cnl8ZW58MHx8fHwxNzc2NDM3NDk5fDA&ixlib=rb-4.1.0&q=85",
    service: "Recuperação de Fios",
    testimonial: "Estava com queda e ressecamento. Em 3 sessões já via diferença. Ezequiela é mágica.",
    client: "Carla S.",
  },
];

export default function BeforeAfter() {
  return (
    <section
      id="galeria"
      data-testid="before-after-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="overline" data-testid="gallery-overline">
            Transformações Reais
          </span>
          <h2
            data-testid="gallery-title"
            className="font-heading text-4xl md:text-5xl font-light tracking-tight mt-4 text-white"
          >
            Antes. Depois. <span className="gold-gradient-text italic">Felizes.</span>
          </h2>
          <div className="gold-line w-24 mt-6 mx-auto" />
          <p className="text-white/60 font-light mt-6">
            Cabelos reais. Clientes reais. Resultados que falam mais alto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {gallery.map((g) => (
            <div
              key={g.id}
              data-testid={`gallery-item-${g.id}`}
              className="group relative overflow-hidden border border-[#222] hover:border-[#D4AF37]/50 transition-colors duration-500"
            >
              <div className="relative h-[500px] overflow-hidden">
                <img
                  src={g.img}
                  alt={`Transformação ${g.service}`}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8">
                <Quote size={28} strokeWidth={1.25} className="text-[#D4AF37] mb-4" />
                <p className="font-heading text-xl md:text-2xl font-light text-white italic leading-snug">
                  "{g.testimonial}"
                </p>
                <div className="flex items-center justify-between mt-5 pt-5 border-t border-white/10">
                  <div>
                    <div className="text-sm text-white font-medium">{g.client}</div>
                    <div className="text-xs text-[#D4AF37] tracking-wider uppercase mt-1">
                      {g.service}
                    </div>
                  </div>
                  <div className="text-[#D4AF37]">★★★★★</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/50 text-sm italic">
            Espaço reservado para suas fotos reais — substitua as imagens de exemplo quando quiser.
          </p>
        </div>
      </div>
    </section>
  );
}
